import editProfileSaga from "./sagas";

const module = [
  {
    importSagas: () => [editProfileSaga],
  },
];

export default module;
